import { render, staticRenderFns } from "./BackAdmin.vue?vue&type=template&id=89e436e4&scoped=true"
import script from "./BackAdmin.vue?vue&type=script&lang=js"
export * from "./BackAdmin.vue?vue&type=script&lang=js"
import style0 from "./BackAdmin.vue?vue&type=style&index=0&id=89e436e4&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89e436e4",
  null
  
)

export default component.exports